import { DomainDetails } from "./LegalPage";

const DOMAIN_DETAILS_URL = "/getDomainName";

const pickFirstValue = (source: any, keys: string[]) => {
  for (const key of keys) {
    const value = source?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return String(value);
    }
  }
  return "";
};

const normalizeDomainDetails = (payload: any): DomainDetails => {
  if (typeof payload === "string" && payload.trim() !== "") {
    return { companyName: payload.trim() };
  }

  const source =
    payload?.response?.data ||
    payload?.response ||
    payload?.data ||
    payload?.domain ||
    payload ||
    {};

  return {
    companyName: pickFirstValue(source, [
      "companyName",
      "company_name",
      "name",
      "businessName",
      "business_name",
    ]),
    domainName: pickFirstValue(source, [
      "domainName",
      "domain_name",
      "domain",
      "host",
    ]),
    email: pickFirstValue(source, [
      "email",
      "emailId",
      "email_id",
      "supportEmail",
    ]),
    phone: pickFirstValue(source, [
      "mobile",
      "mobileNo",
      "mobile_no",
      "phone",
      "phoneNo",
      "contactNo",
      "contact_no",
    ]),
    address: pickFirstValue(source, [
      "address",
      "companyAddress",
      "company_address",
    ]),
  };
};

export const fetchDomainDetails = async (): Promise<DomainDetails> => {
  const response = await fetch(DOMAIN_DETAILS_URL, {
    referrerPolicy: "no-referrer",
  });

  if (!response.ok) {
    throw new Error(`Domain API failed with status ${response.status}`);
  }

  const contentType = response.headers.get("content-type");
  const data =
    contentType && contentType.includes("application/json")
      ? await response.json()
      : await response.text();

  return normalizeDomainDetails(data);
};
